export default __webpack_public_path__ + "static/media/Vector-4.010860e2.svg";